<template>
  <base-view
      @click:add="criar"
      :permiteCadastrar="permiteCadastrar"
      @update:search-values="updateSearch"
      :search-columns="searchColumns">

    <CreateEditFuncionarioDialog :item="item" v-model="editDialogOpened"
                                  @onSave="() => $refs.dataTable.refresh()"/>
    <CreateEditSenhaFuncionarioDialog :item="item" v-model="editSenhaDialogOpened"
                                  @onSave="() => $refs.dataTable.refresh()"/>

    <div>
      <FuncionariosDataTable ref="dataTable"
                            @click:editSenha="editarSenha"
                             @click:edit="editar"
                             @click:remove="remover"
                             @click:ativarUsuario="alterarStatus"
                             @click:desativarUsuario="alterarStatus"
                         :search-values="searchValues"/>
    </div>
    <v-overlay :value="loading" absolute>
      <v-progress-circular
        indeterminate
        color="primary"
        class="ma-4"
      ></v-progress-circular>
    </v-overlay>    
  </base-view>

</template>

<script>
import FuncionariosDataTable from "../../components/shared/datatables/FuncionariosDataTable";
import BaseView from "../BaseView";
import {findOne,remove, mudarStatus} from "../../api/funcionarios";
import CreateEditFuncionarioDialog from "../../components/shared/dialogs/CreateEditFuncionarioDialog";
import CreateEditSenhaFuncionarioDialog from "../../components/shared/dialogs/CreateEditSenhaFuncionarioDialog";
import {mapActions,mapGetters} from "vuex";
import {ItemDeDominio} from "../../api/itemsDominio";
import {ApiError} from "../../api/core";

export default {
  name: "index",
  components: {CreateEditFuncionarioDialog, CreateEditSenhaFuncionarioDialog, BaseView, FuncionariosDataTable},
  data() {
    return {
      item: null,
      loading: false,
      editDialogOpened: false,
      editSenhaDialogOpened: false,
      permiteCadastrar: false,
      selectedItems: [],
      searchValues: {},
      searchColumns: [
        {
          name: 'Nome',
          column: 'nome',
          type: 'text'
        },
        {
          name: 'Login',
          column: 'login',
          type: 'text'
        },
        {
          name: 'Nível',
          column: 'nivel',
          type: 'select',
          optionsFactory: () => this.fetch({
            itemDominio: ItemDeDominio.NIVEL_ACESSO_USUARIO
          })
        }, 
        {
          name: 'Status',
          column: 'flgStatus',
          type: 'select',
          optionsFactory: () => this.fetch({
            itemDominio: ItemDeDominio.STATUS_PADRAO
          })
        },           
      ]
    }
  },
  computed: {
    ...mapGetters('auth',['user','isAuthenticated','nivelUsuarioLogado']),
  },  
  methods: {
    ...mapActions('itemsDominio', ['fetch']),
    updateSearch(search) {
      this.searchValues = search;
    },
    criar() {
      this.item = {};
      this.editDialogOpened = true;
    },
    async editar(objeto) {
      this.editDialogOpened = this.getUsuario(objeto);
    },  
    editarSenha(objeto) {
      this.editSenhaDialogOpened  = this.getUsuario(objeto);
    },
    async getUsuario(objeto){
      try {
        this.loading = true;
        const retorno = await findOne(objeto.id);
        this.item = retorno.dados[0];
        return true;
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          });
        } else {           
          this.$toast.error(`Não foi possível recuperar os dados do Usuário. Tente Novamente mais tarde.`, {
            timeout: 6000
          });
        }
        return false;
      } finally {
        this.loading = false;
      }
    },
    async remover({id}) {
      try {
        this.loading = true;
        await remove(id);
        this.$toast.success(`Usuário removido com sucesso.`, {
          timeout: 3000
        });
        this.$refs.dataTable.refresh();
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          })
        } else {           
          this.$toast.error(`Não foi possível remover o Usuário.`, {
            timeout: 6000
          })
        }
      } finally {
        this.loading = false;
      }
    },
    async alterarStatus(obj) {
      try {
        this.loading = true;
        await mudarStatus(obj.id, obj);
        this.$toast.success(`Usuário ${(obj.flgStatus === 'A' ? 'Desativado' : 'Ativado')} com sucesso.`, {
          timeout: 3000
        });
        this.$refs.dataTable.refresh();
      } catch (err) {
        if (err instanceof ApiError) {
          this.$toast.error(err.message, {
            timeout: 6000
          })
        } else {
          this.$toast.error(`Não foi possível ${(obj.flgStatus === 'A' ? 'Desativar' : 'Ativar')} o Usuário.`, {
            timeout: 6000
          })
        }
      } finally {
        this.loading = false;
      }
    },
	  async getPermissoes(){
      this.getPermissaoPorItemPerfil("Funcionario.cadastro",this.nivelUsuarioLogado)
        .then(permissao => {
          this.permiteCadastrar = permissao;
        });
    },
  },
  mounted() {
    this.getPermissoes();
  }
}
</script>

<style scoped lang="scss">

::v-deep {
  .v-data-table__wrapper {
    height: calc(100vh - 157px);
  }
}

</style>